module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-1260.d75b9da6.svg";